module.exports = __webpack_public_path__ + "static/media/mob-quiz1.2de34a0e.jpg";